/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import { NavBarContainer, SubNavContainer } from "./navBarStyles.js";
import { NavItem } from "./NavItem/index.js";

export const NavBar = ({ navItems, subNavItems, showNavBar, closeNavBar }) => {
  const navItemsList = navItems.map((item) => (
    <NavItem key={item.id} navItem={item} closeNavBar={closeNavBar} />
  ));

  const subNavItemsList = subNavItems.map((item) => (
    <NavItem key={item.id} navItem={item} closeNavBar={closeNavBar} />
  ));

  return (
    <>
      <NavBarContainer showNavBar={showNavBar}>
        {navItemsList}
        <SubNavContainer>{subNavItemsList}</SubNavContainer>
      </NavBarContainer>
    </>
  );
};

NavBar.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      iconSrc: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  subNavItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      iconSrc: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  showNavBar: PropTypes.bool.isRequired,
  closeNavBar: PropTypes.func.isRequired,
};
